/**
 * Created by Ivan on 07.07.2026
 */

const StickersComponent = function (collection) {
    return Prefab.instantiate(bundles.stickers_collection_window.jsons.stickers_component_prefab_json, { collection });
};
